import styled from "styled-components";
import { IconButton, TableCell } from "@mui/material";
import { Container as ContainerBoxGrid } from "@/main/components/shared/boxGrid/styles";

export const Container = styled.div`
	margin: 1rem 0 0 0;
	width: 100%;

	.MuiTextField-root {
		border: 1px solid ${({ theme }) => theme.grayDark};
	}
`;

export const AreaTitleCard = styled.div`
	display: flex;
	align-items: center;
`;
export const TitleCard = styled.h4`
	margin: 0.4rem;
	display: flex;
`;

export const ContainerGrid = styled.div`
	width: 100%;
	.MuiTableCell-root.MuiTableCell-head {
		padding: 6px 4px !important;
	}
	colgroup col {
		transition: width 0.3s ease;
	}
	> ${ContainerBoxGrid} {
		margin: 0;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;

		&&& {
			table {
				min-width: 1100px;
			}
		}
	}
`;
export const ButtonInfo = styled(IconButton)`
	&&& {
		color: ${({ theme }) => theme.pantone2726C};
	}
`;

export const RowTitleHeader = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const QuoteProcurementPartInfoRowTooltip = styled.p`
	flex: 0 1 auto;
	min-width: 0;
	max-width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	margin: 0;
`;

export const EllipsisCell = styled.div`
	width: 100%;
	max-width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

export const NoPriceLabel = styled.p`
	color: ${({ theme }) => theme.red};
	font-size: 0.7rem;
	margin: 0;
`;

export const AreaCollumnPart = styled.div`
	display: flex;
	flex-direction: column;
`;
export const AreaPartName = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 4px;
	min-width: 0;
`;

export const AreaIconPartInfo = styled.div`
	display: flex;
	align-items: center;
	flex-shrink: 0;
`;

export const ButtonIconPartInfo = styled(IconButton)`
	&&& {
		padding: 0;
	}
`;

// Table styles
interface ITableCellGrid {
	$showMobile?: boolean;
	$hideColumn?: boolean;
}

interface ITextAlignTable {
	$textAlign?: "right" | "center" | "left";
}
export const TextAlignTable = styled.div<ITextAlignTable>`
	width: 100%;
	text-align: ${(prop) => (prop.$textAlign ? prop.$textAlign : "left")};
`;
export const TableCellGrid = styled(TableCell)<ITableCellGrid>`
	&&& {
		padding: 6px 4px !important;
		${(props) => props.$hideColumn && "display: none;"}

		/* styles to dropdown MUI */
    .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon
    .MuiAutocomplete-inputRoot[class*='MuiFilledInput-root'] {
			padding-right: 30px;
		}
		.MuiTextField-root {
			min-width: 80px;
			width: 100%;
			max-width: 100%;
		}

		.MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]
			.MuiAutocomplete-input {
			min-width: 50px;
		}
	}
`;

export const TextAsterisk = styled.span`
	color: ${({ theme }) => theme.red};
`;

export const TableCellInputNumber = styled(TableCellGrid)`
	vertical-align: middle !important;
	text-align: center !important;

	.MuiInputBase-input {
		text-align: center;
	}

	.MuiTextField-root {
		min-width: 50px !important;
		max-width: 100% !important;
	}
`;

export const AreaCheckbox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 0.4rem;
	width: 100%;

	&&& {
		.MuiTextField-root,
		.MuiAutocomplete-root {
			width: 100%;
			max-width: 100%;
			min-width: 0;
		}

		.MuiAutocomplete-root .MuiFilledInput-root {
			padding-right: 40px !important;
		}

		.MuiAutocomplete-root .MuiAutocomplete-input {
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			min-width: 0 !important;
		}

		.MuiCheckbox-root {
			margin: 0 auto;
		}

		.MuiCheckbox-root.Mui-disabled {
			color: ${({ theme }) => theme.grayDark};
		}
	}

	.MuiFormControlLabel-root {
		margin: 0;
		align-self: center;
	}
`;

export const TitleHeaderCheckbox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	min-width: 50px;

	> span {
		padding: 0;
		flex: 0 0 auto;
		align-self: center;
	}
`;

export const ContainerTitle = styled.div`
	display: flex;
	flex-direction: column;

	> p {
		margin: 0;
		padding: 0;
	}
`;

export const PartTypeContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
	justify-content: space-between;
`;

export const ImageIconWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ImageBadge = styled.span`
	position: absolute;
	right: -4px;
	bottom: -4px;

	width: 14px;
	height: 14px;

	border-radius: 50%;
	background-color: ${({ theme }) => theme.pantone2726C};
	color: white;

	display: flex;
	align-items: center;
	justify-content: center;

	font-size: 9px;
	font-weight: bold;
`;
